import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/auth';

const SignupButton = () => {
  const { user } = useAuth();

  // Don't show sign up button if user is signed in
  if (user) {
    return null;
  }

  return (
    <Link to="/auth?tab=signup">
      <Button size="sm" className="px-4 py-1.5 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors">
        Sign up
      </Button>
    </Link>
  );
};

export default SignupButton;